// Kundeanmeldelser fra Facebook — tilføj flere efterhånden som de kommer ind.
//
// Felter:
//   name       Kundens navn
//   text       Anmeldelsens tekst
//   source     Hvor anmeldelsen kommer fra (fx "Facebook")
//   projectSlug (valgfri) — hvis den refererer til en specifik opgave, bindes de sammen

export const testimonials = [
    {
        name: "Karsten Milton",
        text: "Markus fra Fyr og Finér bestilte og monterede mine 5 nye inderdøre. Super flot resultat. Er meget tilfreds.",
        source: "Facebook",
    },
];
